import { render, staticRenderFns } from "./VerifyIdentityPopup.vue?vue&type=template&id=cd99342c&scoped=true"
import script from "./VerifyIdentityPopup.vue?vue&type=script&lang=js"
export * from "./VerifyIdentityPopup.vue?vue&type=script&lang=js"
import style0 from "./VerifyIdentityPopup.vue?vue&type=style&index=0&id=cd99342c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd99342c",
  null
  
)

export default component.exports